import React from 'react';
import isArray from 'lodash/isArray';

import PageLayout from 'layouts/PageLayout';
import Sidebar from 'scenes/Sidebar/';
import Form from 'scenes/Form/';
import AddRecommendationForm from 'scenes/Form/components/AddRecommendationForm';
import BasicDialog from 'scenes/Dialog/components/BasicDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import CtaBanner from 'scenes/Sidebar/components/CtaBanner';
import RelatedJobs from 'scenes/Sidebar/components/RelatedJobs';

import { ERROR_FIELD } from 'constants/error-fields';

import ctaBackground from 'assets/images/cta_back_signup.jpg';
import './styles.css';

class AddRecommendation extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      token: null,
    };
  }

  componentWillMount() {
    this._isMounted = true;
    const token = new URLSearchParams(this.props.history.location.search).get(
      'token'
    );
    if (!token) {
      this.handleNotFound();
    } else {
      this.setState({ token });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  redirect = () => {
    if (this._isMounted) {
      if (this.props.user.isLoggedIn) {
        this.props.history.replace('/home');
      } else {
        window.location = '/';
      }
    }
  };

  handleAfterSaveForm = () => {
    BasicDialog({ bodyRender: 'Thank you for your recommendation!' }).then(
      this.redirect
    );
    setTimeout(this.redirect, 1000);
  };

  handleError = (response, setErrors) => {
    const {
      data: { fields },
    } = response;
    if (fields && typeof setErrors === 'function') {
      const obj = {};
      for (let [key, value] of Object.entries(fields)) {
        const error = isArray(value) ? value[0] : value;
        obj[key] = ERROR_FIELD[error] || `${error}`;
      }
      setErrors(obj);
    } else {
      ResponseErrorDialog({ response });
    }
  };

  handleNotFound = () => {
    this.props.history.replace('/404');
  };

  render() {
    const { token } = this.state;
    return (
      token && (
        <PageLayout
          pageClass="add-recommendation"
          pageTitle={this.props.pageTitle}
          mainContent={
            <Form>
              <AddRecommendationForm
                params={{ token }}
                actions={{
                  proceed: this.handleAfterSaveForm,
                  onNotFoundHandler: this.handleNotFound,
                  onErrorHandler: this.handleError,
                }}
              />
            </Form>
          }
          sidebarContent={
            <Sidebar>
              <CtaBanner
                blockHeight="150"
                blockBg={ctaBackground}
                blockText="Recruit Talent Through GoBuyside"
                blockFontSize="20"
              />
              <RelatedJobs
                user={this.props.user}
                history={this.props.history}
              />
            </Sidebar>
          }
        />
      )
    );
  }
}

export default AddRecommendation;
